module.exports = __webpack_public_path__ + "static/Vray-9ec4c3b8d33223e1cedf3de93c541a39.png";